import React from "react";
import { Alert } from "@mui/material";
import { useAdminDataGuard } from "../hooks/useAdminDataGuard";
import SecurityConsole from "../components/security/SecurityConsole";

const AdminSecurityPage = () => {
  const canAccessAdminData = useAdminDataGuard();

  if (!canAccessAdminData) {
    return <Alert severity='error'>Admin token validation failed.</Alert>;
  }

  return <SecurityConsole />;
};

export default AdminSecurityPage;
